export const getSectionItemComponent = ({
  content,
  isPadded,
  marginBottom,
  width = "100%",
}) => `
            <td
            style="
                font-size: 0px;
                padding: 20px 0;
                padding-top: 0;
                padding-right: 4px;
                padding-bottom: 0;
                padding-left: 4px;
                word-break: break-word;
            "
            >
            <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:598px;" width="598" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
            <div
                style="margin: 0px auto; max-width: 598px"
            >
                <table
                align="center"
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style="
                    width: ${width};
                    ${marginBottom ? `margin-bottom: ${marginBottom};` : ""}
                "
                >
                <tbody>
                    <tr>
                    <td
                        style="
                        direction: ltr;
                        font-size: 0px;
                        padding: 20px 0;
                        padding-bottom: 0;
                        padding-left: 4px;
                        padding-right: 4px;
                        padding-top: 0;
                        text-align: center;
                        "
                    >
                        <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:590px;" ><![endif]-->
                        <div
                        class="mj-column-per-100 mj-outlook-group-fix"
                        style="
                            font-size: 0px;
                            text-align: left;
                            direction: ltr;
                            display: inline-block;
                            vertical-align: top;
                            width: 100%;
                        "
                        >
                        <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                            background-color: #ffffff;
                            border-radius: 4px;
                            vertical-align: top;
                            "
                            width="100%"
                        >
                            <tbody>
                            <tr>
                                <td
                                align="left"
                                style="
                                    font-size: 0px;
                                    ${isPadded ? "padding: 10px 8px;" : ""}
                                    word-break: break-word;
                                "
                                >
                                <div
                                    style="
                                    font-family: Roboto, Arial;
                                    font-size: 12px;
                                    line-height: 1;
                                    text-align: left;
                                    color: #263238;
                                    "
                                >
                                    ${content}
                                </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
`;
